// Rutas de la plataforma nueva, armadas desde el registro de módulos. Cada página es un chunk aparte; sin el
// módulo se redirige (el backend también valida). Las rutas sinShell (impresión) van sin menú ni encabezado.
// ToastProvider es global: cualquier módulo usa useToast() (ds/components/feedback/Toast); el shell pinta el
// ToastViewport.
// Errores (como App.js): cada página tiene su límite con la etiqueta 'app' (App.js:578; la clave del módulo va en
// metadata.page_module) y TODO el shell (menú, encabezado, navegación del módulo) va dentro de 'app_root'
// (App.js:740-744): un error del menú ya no deja la pantalla en blanco.
import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastProvider } from '../../ds/components/feedback/Toast';
import { MODULOS } from '../modulos/registro';
import { tieneModulo, useConfigUsuario } from './ConfigUsuario';
import Shell from '../shell/Shell';
import { CargandoPagina } from '../comun/Estados';
import { LimiteDeError } from '../comun/LimiteDeError';

function Protegida({ modulo, children }) {
  const { features, featuresListas } = useConfigUsuario();
  if (!featuresListas) return <CargandoPagina />;
  if (!tieneModulo(features, modulo)) return <Navigate to={modulo.fallback ?? '/'} replace />;
  return children;
}

function pagina(modulo, { Pagina }) {
  return (
    <LimiteDeError modulo="app" pagina={modulo.clave}>
      <Protegida modulo={modulo}>
        <Suspense fallback={<CargandoPagina />}>
          <Pagina />
        </Suspense>
      </Protegida>
    </LimiteDeError>
  );
}

const RUTAS = MODULOS.flatMap((m) => m.rutas.map((r) => ({ modulo: m, ...r })));

export default function Rutas() {
  return (
    <ToastProvider>
      <Routes>
        {RUTAS.filter((r) => r.sinShell).map((r) => (
          <Route key={r.ruta} path={r.ruta} element={pagina(r.modulo, r)} />
        ))}
        <Route element={<LimiteDeError modulo="app_root" variante="pantalla"><Shell /></LimiteDeError>}>
          {RUTAS.filter((r) => !r.sinShell).map((r) => (
            <Route key={r.ruta} path={r.ruta} element={pagina(r.modulo, r)} />
          ))}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </ToastProvider>
  );
}
